import { render, staticRenderFns } from "./emisionpaquetes.vue?vue&type=template&id=13410df2"
import script from "./emisionpaquetes.vue?vue&type=script&lang=js"
export * from "./emisionpaquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports